import {outter_post} from 'common/js/axios-helper';
import {OrganAuthApi} from "./constant/UrlMapper";




const host = '8880';
const list = (data) => {
    return outter_post(OrganAuthApi.List, data, host);
};

const update = (data) => {
    return outter_post(OrganAuthApi.Update, data, host);
};

const add = (data) => {
    return outter_post(OrganAuthApi.Add, data, host);
};

const dpstatus = (data) => {
    return outter_post(OrganAuthApi.DpStatus, data, host);
};

const detail = (data) => {
    return outter_post(OrganAuthApi.Detail, data, host);
};

const getShortNames = (data) => {
    return outter_post(OrganAuthApi.GetShortNames, data, host);
};

const isExist = (data) => {
    return outter_post(OrganAuthApi.IsExist, data, host);
};

const delInfo = (data) => {
    return outter_post(OrganAuthApi.Delete, data, host);
};

const isExistTatAndTradingType = (data) => {
    return outter_post(OrganAuthApi.IsExistTatAndTradingType, data, host);
};


export default {list, update, add, dpstatus, detail, getShortNames, isExist, delInfo, isExistTatAndTradingType}



// WEBPACK FOOTER //
// ./src/service/OrganAuthService.js